import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda/src/index';
import LazyImage from 'helpers/LazyImage';
import {google, trustpilot, imageSource} from 'ferries/Home/components/Testimonials/helper';

const MAX_STARS = 5;

const BenefitColumnReview = ({isGoogle, url, stars, rating, text}) => {
  const hasHalfStar = rating % 1 !== 0 && rating % 1 <= .5;
  const fullStars = hasHalfStar ? Math.floor(rating) : Math.round(rating);
  const emptyStars = MAX_STARS - fullStars - (hasHalfStar ? 1 : 0);
  const imageKey = isGoogle ? google : trustpilot;
  const image = imageSource[imageKey];

  return (
    <a
      href={url}
      className="display-4 text-white d-block text-decoration-none"
      target="_blank"
      rel="noreferrer"
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="" style={{fontSize: '48px'}}>
          <b>{stars}</b>
        </div>
        <LazyImage
          imgClass='mb-2'
          src={image.src}
          title={image.title}
          alt={image.alt}
          width='32px'
          height='32px'
        />
      </div>
      <div className="my-1">
        {R.range(0, fullStars).map((star) =>
          <i key={star} className="icon icon-shape-star-4 icon-24 text-warning" />
        )}
        {hasHalfStar && (
          <i className="icon icon-shape-star-4 icon-24 half-star" />
        )}
        {R.range(0, emptyStars).map((star) =>
          <i key={star} className="icon icon-shape-star-4 icon-24 text-white" />
        )}
      </div>
      {text &&
        <div className="my-2">{text}</div>}
    </a>
  );
};

BenefitColumnReview.defaulProps = {
  isGoogle: false
};

BenefitColumnReview.propTypes = {
  isGoogle: PropTypes.bool,
  rating: PropTypes.number.isRequired,
  stars: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  text: PropTypes.string
};

export default BenefitColumnReview;
